export const registerServiceWorker = ({ onUpdate } = {}) => {
  if (!('serviceWorker' in navigator)) return Promise.resolve(null);
  if (!import.meta.env.PROD) return Promise.resolve(null);

  return new Promise((resolve) => {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          registration.addEventListener('updatefound', () => {
            const worker = registration.installing;
            if (!worker) return;

            worker.addEventListener('statechange', () => {
              if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                onUpdate?.(registration);
                window.dispatchEvent(new CustomEvent('eduvibz:pwa-update-ready', {
                  detail: { registration }
                }));
              }
            });
          });

          resolve(registration);
        })
        .catch(() => {
          // Service worker registration should never block the app.
          resolve(null);
        });
    }, { once: true });
  });
};

export const activateWaitingServiceWorker = async (registration) => {
  const waitingWorker = registration?.waiting;
  if (!waitingWorker) return false;

  waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  return true;
};

export const refreshServiceWorkerRegistration = async (registration) => {
  if (!registration?.update) return false;

  try {
    await registration.update();
    return true;
  } catch {
    return false;
  }
};
